import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";

class DatePicker extends Component {
    constructor(props) {
        super(props);

        this.updateValue = this.updateValue.bind(this);
        this.attachDatepicker = this.attachDatepicker.bind(this);

        this.state = {
            loading_datepicker: true,
            current_date: moment().startOf('day'),
            unavailable_dates: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (! (moment(nextProps.value, "MMM YYYY").startOf('day').isSame(this.state.current_date.startOf('day')))) {
            this.setState({
                current_date: moment(nextProps.value, "MMM DD, YYYY").startOf('day')
            })
        }
    }

    componentDidMount() {
        var self = this;
        this.setState({
            current_date:  moment(this.props.value, "MMM DD, YYYY").startOf('day')
        })

        if("vehicle_id" in self.props || "booking_id" in self.props) {

            var url = "";
            var type;

            if("vehicle_id" in self.props) {
                url = "/ajax/vehicle/" + self.props.vehicle_id + "/unavailable_dates";
            } else {
                url = "/ajax/booking/" + self.props.booking_id + "/unavailable_dates";
            }

            if("name" in self.props) {
                if(self.props.name == "booking_end_date")
                {
                    type = "dropoff"
                }
                else if(self.props.name == "booking_start_date")
                {
                    type = "pickup"
                }
            }

            axios.post(url, {
                type: type
            })
            .then(function(response) {
                self.setState({
                    unavailable_dates: response?.data,
                })
                self.attachDatepicker();
            })
            .catch(function(error) {
                if(error.response?.status == 401) {
                    showStatusMsg(error.response?.data?.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else {
            self.attachDatepicker();
        }
    }

    attachDatepicker() {
        var self = this;

        self.setState({
            loading_datepicker: false
        })

        if("vehicle_id" in self.props) {
            var parsed_unavailable_dates = [];
            $.map(this.state.unavailable_dates, function (key, value) {
                parsed_unavailable_dates.push([value, key]);
            });

            $("#" + self.props.id).datepicker({
                dateFormat: 'M d, yy',
                minDate: ((self.props.id).indexOf("booking_end_date") !== -1 && "start_date_id" in self.props ? (new Date($('#' + self.props.start_date_id).val())) : 0),
                ignoreReadonly: true,
                allowInputToggle: true,
                beforeShowDay: function beforeShowDay(date) {
                    return updateUnavailableDates(date, parsed_unavailable_dates, $(this), ((self.props.id).indexOf("booking_end_date") !== -1 && "start_date_id" in self.props ? $('#' + self.props.start_date_id) : $(this)), ((self.props.id).indexOf("booking_end_date") !== -1 ? true : false));          
                },
                onSelect: function(date) {
                    self.setState({
                        current_date: moment(date, "MMM DD, YYYY").startOf('day')
                    })
                    self.props.updateValue({target: {type: "text", name: self.props.name, value: self.state.current_date.format("MMM DD, YYYY")}});
                },
                onClose: function onClose(dateText, inst) {
                    date_flag = false;

                    if (self.state.current_date) {
                        $('#' + self.props.id).datepicker('setDate', moment(self.state.current_date).toDate());
                    }
                },
                onChangeMonthYear: function onChangeMonthYear(year, month, inst) {
                    date_flag = false;
                },
                beforeShow: function beforeShow(input, inst) {
                    $(this).blur();
                    var calendar = inst.dpDiv;
                    setTimeout(function () {
                        calendar.position({
                            my: 'center top',
                            at: 'center bottom',
                            collision: 'fit flip',
                            of: input
                        });
                    }, 1);
                }
            });
        } else if("booking_id" in self.props) {
            var parsed_unavailable_dates = [];
            $.map(this.state.unavailable_dates, function (key, value) {
                parsed_unavailable_dates.push([value, key]);
            });

            $("#" + self.props.id).datepicker({
                dateFormat: 'M d, yy',
                minDate: (self.props.id == "edit-end-date" && "start_date_id" in self.props ? (new Date($('#' + self.props.start_date_id).val())) : 0),
                ignoreReadonly: true,
                allowInputToggle: true,
                beforeShowDay: function beforeShowDay(date) {
                    return updateUnavailableDates(date, parsed_unavailable_dates, $(this), (self.props.id == "edit-end-date" && "start_date_id" in self.props ? $('#' + self.props.start_date_id) : $(this)), (self.props.id == "edit-end-date" ? true : false));
                },
                onSelect: function(date) {
                    self.setState({
                        current_date: moment(date, "MMM DD, YYYY").startOf('day')
                    })
                    self.props.updateValue({target: {type: "text", name: self.props.name, value: self.state.current_date.format("MMM DD, YYYY")}});
                },
                onClose: function onClose(dateText, inst) {
                    date_flag = false;

                    if (self.state.current_date) {
                        $('#' + self.props.id).datepicker('setDate', moment(self.state.current_date).toDate());
                    }
                },
                onChangeMonthYear: function onChangeMonthYear(year, month, inst) {
                    date_flag = false;
                },
                beforeShow: function beforeShow(input, inst) {
                    $(this).blur();
                    var calendar = inst.dpDiv;
                    setTimeout(function () {
                        calendar.position({
                            my: 'center top',
                            at: 'center bottom',
                            collision: 'fit flip',
                            of: input
                        });
                    }, 1);
                }
            });
        } else if("show_months_only" in self.props) {
            $("#" + self.props.id).datepicker({
                dateFormat: 'MM yy',
                changeMonth: true,
                changeYear: true,
                showButtonPanel: true,
                ignoreReadonly: true,
                allowInputToggle: true,
                beforeShow: function(){ $(this).blur(); },
                onClose: function(dateText, inst) {
                    var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
                    var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
                    var date = $.datepicker.formatDate('MM yy', new Date(year, month, 1));
                    self.setState({
                        current_date: moment(date, "MMMM YYYY").startOf('day')
                    })
                    self.props.updateValue({target: {type: "text", name: self.props.name, value: self.state.current_date.format("MMMM YYYY")}});
                },
                onSelect: function(date) {
                    self.setState({
                        current_date: moment(date, "MMMM YYYY").startOf('day')
                    })
                    self.props.updateValue({target: {type: "text", name: self.props.name, value: self.state.current_date.format("MMMM YYYY")}});
                },
            });

            $("#" + self.props.id).focus(function () {
                $(".ui-datepicker-calendar").hide();
                $("#ui-datepicker-div").position({
                    my: "center top",
                    at: "center bottom",
                    of: $(this)
                });
            });
        } else {
            $("#" + self.props.id).datepicker({
                dateFormat: 'M d, yy',
                minDate: ("mindate" in this.props && this.props.mindate ? (new Date(this.props.mindate)) : null),
                maxDate: ("maxdate" in this.props && this.props.maxdate ? (new Date(this.props.maxdate)) : null),
                ignoreReadonly: true,
                allowInputToggle: true,
                onSelect: function(date) {
                    self.setState({
                        current_date: moment(date, "MMM DD, YYYY").startOf('day')
                    })
                    self.props.updateValue({target: {type: "text", name: self.props.name, value: self.state.current_date.format("MMM DD, YYYY")}});
                },
                beforeShow: function (input, inst) {
                    $(this).blur();
                    if("attach_to_input" in self.props && self.props.attach_to_input) {
                        setTimeout(function () {
                            inst.dpDiv.css({
                                top: $("#" + self.props.id).offset().top + 35,
                                left: $("#" + self.props.id).offset().left
                            });
                        }, 0);
                    }
                },
            });
        }

        if (self.props.value) {
            $('#' + self.props.id).datepicker('setDate', moment(self.props.value).toDate());
        }
    }

    updateValue(event) {
    }

    render() {
        return (
            <input type="text" id={"id" in this.props ? this.props.id : ""} className={"classname" in this.props ? (this.props.classname + " no-readonly-style") : "no-readonly-style"} 
                name={"name" in this.props ? this.props.name : ""} placeholder={"placeholder" in this.props ? this.props.placeholder : "" } 
                    value={"value" in this.props && this.props.value != "" ? ("show_months_only" in this.props ? this.state.current_date.clone().format("MMMM YYYY") : this.state.current_date.clone().format("MMM DD, YYYY")) : ""} disabled={"disabled" in this.props ? this.props.disabled : ""} 
                        onChange={"onChange" in this.props ? this.updateValue : null}  readOnly={true} />
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(DatePicker)